var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-modal",
    {
      attrs: { size: "small", closable: false },
      model: {
        value: _vm.open,
        callback: function ($$v) {
          _vm.open = $$v
        },
        expression: "open",
      },
    },
    [
      _c("sui-modal-header", { staticStyle: { "text-align": "center" } }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      _c(
        "sui-modal-content",
        { attrs: { scrolling: "" } },
        [
          _c("ModalForm", {
            ref: "form",
            attrs: {
              feeSchedule: _vm.feeSchedule,
              firms: _vm.firms,
              financialAdvisors: _vm.financialAdvisors,
              reset: _vm.reset,
              isCreate: _vm.isCreate,
            },
            on: {
              toggleModal: _vm.toggleModal,
              toggleIsCreate: _vm.toggleIsCreate,
            },
          }),
        ],
        1
      ),
      _c(
        "sui-modal-actions",
        [
          _c("sui-button", {
            attrs: {
              type: "button",
              basic: "",
              size: "small",
              color: "grey",
              content: "Cancel",
            },
            on: { click: _vm.cancel, toggleIsCreate: _vm.toggleIsCreate },
          }),
          _c("sui-button", {
            attrs: {
              primary: "",
              size: "small",
              type: "button",
              content: "Save",
            },
            on: { toggleIsCreate: _vm.toggleIsCreate },
            nativeOn: {
              click: function ($event) {
                return _vm.save.apply(null, arguments)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }